import {
    REQUEST_INCENTIVES,
    REQUEST_INCENTIVES_FAILURE, REQUEST_INCENTIVES_SUCCESS,
} from "../../constant/other/IncentiveConstant";

const initialState = {
    incentives: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const incentivesReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_INCENTIVES:
            return {
                ...state,
                incentives: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_INCENTIVES_SUCCESS:
            return {
                ...state,
                incentives: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_INCENTIVES_FAILURE:
            return {
                ...state,
                incentives: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
